__turbopack_context__.v({
  "direction-column": "mochi-radio-group-module-scss-module__w8cbyW__direction-column",
  "direction-row": "mochi-radio-group-module-scss-module__w8cbyW__direction-row",
  "mochi-radio-group": "mochi-radio-group-module-scss-module__w8cbyW__mochi-radio-group",
});
